// filepath: src/components/inventory/InventoryGrid.js
import React from "react";
import ProductCard from '../../CommonComponents/ProductCard';
import { MdEdit } from "react-icons/md";




const InventoryGrid = ({ inventories, onAdjust, onEdit, uploadsBaseURL }) => (
    <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-4">
        {inventories.map(inv => {
            const name = inv.name || inv.product_name || inv.raw_material_name || '-';
            const type = inv.product_id ? 'Product' : inv.raw_material_id ? 'Raw Material' : '-';
            const unit = inv.unit_type || inv.unit || '-';
            return (
                <div key={inv.id}>
                    <ProductCard
                        product={{
                            id: inv.id,
                            name: name,
                            image: inv.image_url ? `${uploadsBaseURL}/${inv.image_url}` : null,
                            stock: inv.quantity,
                            description: inv.description || inv.product_description || '',
                            price: typeof inv.price === 'number' && inv.price > 0 ? inv.price : '',
                        }}
                        showAddToCart={false}
                        showEdit={false}
                        onIncrease={e => { if (e) e.stopPropagation(); onAdjust(inv, +1); }}
                        onDecrease={e => { if (e) e.stopPropagation(); onAdjust(inv, -1); }}
                        uploadsBaseURL={uploadsBaseURL}
                        mode="inventory"
                    >
                        <div className="ml-2 mt-2 flex flex-col items-start">
                            <span className="text-xs font-semibold px-2 py-1 rounded bg-gray-200 mb-1">{type}</span>
                            <button
                                type="button"
                                onClick={onEdit ? () => onEdit(inv) : undefined}
                                className="cursor-pointer w-7 h-7 rounded-md flex items-center justify-center"
                                style={{
                                    background: 'var(--color-primary)',
                                    color: 'var(--color-text, #fff)',
                                    transition: 'background 0.2s',
                                }}
                                onMouseOver={e => e.currentTarget.style.background = 'var(--color-active)'}
                                onMouseOut={e => e.currentTarget.style.background = 'var(--color-primary)'}
                                title="Edit"
                            >
                                <MdEdit size={14} color="#fff" />
                            </button>
                        </div>
                    </ProductCard>
                </div>
            );
        })}
    </div>
);

export default InventoryGrid;
